import { EditablePaymentSettings } from 'modules/profile/payment/types/payment-settings-interface'
import { getEmptyLocaleValues } from 'shared/utils/get-empty-locale-values'

export const defaultValues: EditablePaymentSettings = {
  defaultCurrency: undefined,
  doNotUseVat: false,
  doNotUseVatForSwitzerland: false,
  paymentPageAgreement: getEmptyLocaleValues(),
  salesInvoiceFooter: getEmptyLocaleValues(),
  subscriptionGivingAccess: undefined,
}
